import api from './ApiService.js';

const GoogleSheetService = {
    async getFabrics() {
        try {
            const response = await api.get('/api/fabrics');
         
            return response.data;
        } catch (error) {
            console.error('Error fetching fabrics:', error);
            throw error;
        }
    },

    async getData(endpoint) {
        try {
            const response = await api.get(endpoint);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async postData(endpoint, data) {
        try {
            const response = await api.post(endpoint, data);
            return response.data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    },

    async updateData(endpoint, data) {
        try {
            const response = await api.put(endpoint, data);
            return response.data;
        } catch (error) {
            console.error('Error updating data:', error);
            throw error;
        }
    },

    async deleteData(endpoint) {
        try {
            const response = await api.delete(endpoint);
            return response.data;
        } catch (error) {
            console.error('Error deleting data:', error);
            throw error;
        }
    }
};

export default GoogleSheetService;